import { createSelector } from 'reselect';

const selectdbnbizsubscriptions = (state: any) => state.dbnbizsubscriptions;


export const selectdbnbizsubscriptionsCurrentItem = createSelector([selectdbnbizsubscriptions], (dbnbizsubscriptions) => dbnbizsubscriptions.current);

export const selectdbnbizsubscriptionsListItems = createSelector([selectdbnbizsubscriptions], (dbnbizsubscriptions) => dbnbizsubscriptions.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectdbnbizsubscriptionsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectdbnbizsubscriptionsQueryItems = createSelector([selectdbnbizsubscriptions], (dbnbizsubscriptions) => dbnbizsubscriptions.query);

export const selectdbnbizsubscriptionsCreatedItem = createSelector([selectdbnbizsubscriptions], (dbnbizsubscriptions) => dbnbizsubscriptions.create);

export const selectdbnbizsubscriptionsUpdatedItem = createSelector([selectdbnbizsubscriptions], (dbnbizsubscriptions) => dbnbizsubscriptions.update);

export const selectdbnbizsubscriptionsReadItem = createSelector([selectdbnbizsubscriptions], (dbnbizsubscriptions) => dbnbizsubscriptions.read);

export const selectdbnbizsubscriptionsDeletedItem = createSelector([selectdbnbizsubscriptions], (dbnbizsubscriptions) => dbnbizsubscriptions.delete);

export const selectdbnbizsubscriptionsSearchedItems = createSelector([selectdbnbizsubscriptions], (dbnbizsubscriptions) => dbnbizsubscriptions.search);

export const selectdbnbizsubscriptionsItemsCount = createSelector([selectdbnbizsubscriptions], (dbnbizsubscriptions) => dbnbizsubscriptions.count);

export const selectdbnbizsubscriptionsItemsFilter = createSelector([selectdbnbizsubscriptions], (dbnbizsubscriptions) => dbnbizsubscriptions.filter);